export const disableNumbersOfTxtField=(ev)=>{

if(ev.keyCode === 38 || ev.keyCode === 40){
    ev.preventDefault();
}
}